<template>
    <div class="full">
        <h3 class="block-title text-center" v-if="content.meta.title">
            <span class="block-title-content  theme-tinted-border">{{this.content.meta.title}}</span>
        </h3>

        <videos :videos="content.data.videos" />
    </div>
</template>

<script>
import Videos from './Videos.vue';
export default {
    components: { Videos },
    props: ['block', 'providerId', 'context'],
    data() {
        return {
            content: JSON.parse(this.block.content),
            informationBlock: this.block.information_block
        };
    },
    computed: {
        title: function() {
            return this.content.meta.title || this.informationBlock.title;
        }
    }
}
</script>

<style scoped></style>
